module.exports = __webpack_public_path__ + "ddff6019c9ccbc713344d597b5cbcfbe.pdf";